import "./component3.scss";
import React from "react";
import { PHONE_BOOKING_TEL } from "../../constants/contact";

const Component3 = () => {
  return (
    <section className="pricing component3" id="prices">
      <div className="container">
        <p className="section-label pricing__label">Тарифы</p>
        <h2 className="pricing__title">Стоимость столов</h2>
        <p className="pricing__hint">
          Актуальные условия и бронирование —{" "}
          <a href={PHONE_BOOKING_TEL}>наберите нам напрямую</a>.
        </p>

        <div className="pricing__grid">
          <article className="price-card">
            <h3 className="price-card__title">Русский бильярд</h3>
            <ul className="price-card__list">
              <li>
                <span>Пн–Пт · 14:00–18:00</span>
                <strong>800 ₽ / час</strong>
              </li>
              <li>
                <span>Пн–Чт · 18:00–01:00</span>
                <strong>950 ₽ / час</strong>
              </li>
              <li>
                <span>Пятница · 18:00–01:00</span>
                <strong>1100 ₽ / час</strong>
              </li>
              <li>
                <span>Выходные · 14:00–01:00</span>
                <strong>1100 ₽ / час</strong>
              </li>
            </ul>
          </article>

          <article className="price-card">
            <h3 className="price-card__title">Пул</h3>
            <ul className="price-card__list">
              {/* <li>
                <span>Пн–Вс · 14:00–01:00</span>
                <strong>650 ₽ / час</strong>
              </li> */}
              <li>
                <span>Пн–Пт · 14:00–18:00</span>
                <strong>800 ₽ / час</strong>
              </li>
              <li>
                <span>Пн–Чт · 18:00–01:00</span>
                <strong>800 ₽ / час</strong>
              </li>
              <li>
                <span>Пятница · 18:00–01:00</span>
                <strong>900 ₽ / час</strong>
              </li>
              <li>
                <span>Выходные · 14:00–01:00</span>
                <strong>900 ₽ / час</strong>
              </li>
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Component3;
